export const enabledOpengateVariants = [4, 5]
